module.exports = __webpack_public_path__ + "img/overclock.71ffb9a0.png";